import React from 'react';
import styled from 'styled-components';
import { Section, Tooltip } from 'components';

export const ContentHeader = styled(Section)`
  padding-bottom: 0;
  z-index: 1;

  > div {
    padding-bottom: 0;
    border-bottom: none;
  }
`;

interface IPayTipsTooltip {
  id: string;
  balance?: number;
}

export const PayTipsTooltip = ({ id, balance }: IPayTipsTooltip) => {
  let tooltip = null;

  if (balance <= 0) {
    tooltip = <Tooltip id={id}>There are currently no funds available to pay these tips</Tooltip>;
  }
  return tooltip;
};
